import { useSyncExternalStore } from 'react';

/** Where the player is: a watch address, its query and its history state. */
export interface WatchLocation {
  pathname: string;
  search: string;
  state: unknown;
}

/**
 * The in-app mini player: the watch page that keeps playing in a corner while you browse. Null
 * when the player is full size or closed.
 */
let mini: WatchLocation | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function useMiniPlayer() {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => mini,
  );
}

export function setMini(loc: WatchLocation | null) {
  mini = loc;
  emit();
}

/** Saves the player's place; set by the watch page while it's open. */
let saveProgress: (() => Promise<void>) | null = null;
export function onPlayerStop(fn: (() => Promise<void>) | null) {
  saveProgress = fn;
}

/**
 * Before signing out or switching profile: saves where the mini player is, while the profile can
 * still save it, then closes it.
 */
export async function stopPlayer() {
  if (!mini) return;
  await saveProgress?.().catch(() => undefined);
  setMini(null);
}
